module.exports = __webpack_public_path__ + "static/media/window-close-regular.8e5570ae.svg";